"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getHoursSafeWithoutTimezone = exports.getDateWithoutTimezone = exports.getDateName = exports.formatDateToDayMonth = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _isValid = _interopRequireDefault(require("date-fns/isValid"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _date = require("./date");

/**
 * Вырезаем таймзону, чтобы показать местное время
 * @param {string} date 2018-12-26T10:00:00.000+03:00
 * @returns {string} 2018-12-26T10:00:00
 */
var getDateWithoutTimezone = function getDateWithoutTimezone(date) {
  var _date$split = date.split('.'),
      _date$split2 = (0, _slicedToArray2["default"])(_date$split, 1),
      dateWithoutTimezone = _date$split2[0];

  var parseDate = new Date(dateWithoutTimezone);
  var isValidDate = (0, _isValid["default"])(parseDate);
  return isValidDate ? dateWithoutTimezone : date;
};
/**
 * Возвращает время из даты безопасно, с фолбеком на текст
 * @param {string} date
 * @param {string} invalidText
 * @returns {string} HH:mm | Неизвестно
 */


exports.getDateWithoutTimezone = getDateWithoutTimezone;

var getHoursSafeWithoutTimezone = function getHoursSafeWithoutTimezone(date) {
  var invalidText = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Неизвестно';
  var dateString = getDateWithoutTimezone(date);
  if (!dateString) return invalidText;
  var parseDate = new Date(dateString);
  return (0, _format["default"])(parseDate, 'HH:mm');
};
/**
 * Форматирует дату, например 23 сен, пт
 * @param {string} date
 * @returns {string}
 */


exports.getHoursSafeWithoutTimezone = getHoursSafeWithoutTimezone;

var formatDateToDayMonth = function formatDateToDayMonth(date) {
  return (0, _date.formatDate)(date, 'dd MMM');
};
/**
 * Возвращает день недели
 * @param {string} date
 * @returns {string} пятница
 */


exports.formatDateToDayMonth = formatDateToDayMonth;

var getDateName = function getDateName(date) {
  return (0, _date.formatDate)(date, 'eeee');
};

exports.getDateName = getDateName;